export default String.raw`
const Deligoo = (() => {
    'use strict';
    const checkAvailability = async (zipCode, products) => {
        const data = {
            __csrf: __CSRF,
            __action: 'Product/FastDeliveryCheck',
            zipCode: zipCode,
            products: JSON.stringify(products)
        };

        try {
            const response = await $.post(null, data);
            const isAvailable = response?.action?.Result;

            return isAvailable;
        } catch (error) {
            console.error("Error checking deligoo delivery: ", error)
        }
    };

    return {
        checkAvailability
    }
})();

const DeligooUI = (() => {
    'use strict';
    const button = document.querySelector('.check-deligoo-availability-js');

    if (!button) {
        return;
    }

    $('body').on('click', '.check-deligoo-availability-js', () => {
        const popup = document.querySelector('.check-deligoo-popup-js');
        popup.showModal();
    });

    const checkDeligooButton = document.querySelector('.check-deligoo-js');
    if (!checkDeligooButton) {
        return;
    }

    $('body').on('click', '.check-deligoo-js', async () => {
        const zipCode = $('.check-deligoo-popup-js input[name="zipCode"]').val();

        const productId = $('.product-presentation-js').data('product-id');
        const supplyId = $('.product-presentation-js').find('.active-js input[name="supplyId"]').val();
    
        let parsedProductId = null;
        if (!isNaN(productId)) {
            parsedProductId = Number(productId);
        }
        
        let parsedSupplyId = null;
        if (!isNaN(supplyId)) {
            parsedSupplyId = Number(supplyId);
        }
        
        const products = [{ 
            ProductId: parsedProductId,
            SupplyId: parsedSupplyId 
        }];
    
        if(!zipCode) {
            return;
        }

        const isAvailable = await Deligoo.checkAvailability(zipCode, products);

        $('.check-deligoo-success-js').toggleClass('hidden-js', !isAvailable);
        $('.check-deligoo-failure-js').toggleClass('hidden-js', isAvailable);
    });
})();




`